import type { EChartsOption } from 'echarts';
import type { GridOption } from 'echarts/types/dist/shared';

import type { TEChartsLoadingOptions } from '../types';

export const CHART_COLORS = ['#00a9ff', '#17f4db'];

export const COLORS = {
  lightGrey: '#A1A6AD',
  blackSt: '#333333',
} as const;

export const ECHARTS_GRID_OPTIONS: GridOption = {
  left: '3%',
  right: '4%',
  bottom: '14%',
  top: '3%',
  containLabel: true,
};

export const ECHARTS_LEGEND_OPTIONS: EChartsOption['legend'] = {
  bottom: 20,
  left: 'center',
  itemGap: 20,
  textStyle: { fontSize: 14, fontFamily: 'Fira Sans' },
};

export const ECHARTS_LOADING_OPTIONS: TEChartsLoadingOptions = {
  text: 'Загрузка...',
};
